import React, { useEffect, useState, useContext } from "react";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Divider,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
/* import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"; */
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { createBooking } from "../../api/Booking/bookingApi"; // Import the API function
import logo from "../../img/logos/logo-dark.svg";
import { makeStyles } from "@mui/styles";

import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TimerOutlinedIcon from "@mui/icons-material/TimerOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";

import { SidebarContext } from "../Sidebar/SidebarProvider";

const useStyles = makeStyles((theme) => ({
  logo: {
    width: "100%",
    maxWidth: "90px",
    margin: "0px 0px 20px 0px",
    display: "block",
  },
}));

const BookingPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { isMinimized } = useContext(SidebarContext);
  const marginLeft = isMinimized ? "4em" : "4em";
  const classes = useStyles();
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/login");
      }
    }
  }, [navigate]);

  const handleBooking = async () => {
    if (!date || !time) {
      alert("Please select both a date and time.");
      return;
    }

    const bookingData = {
      date: date.toISOString().split("T")[0], // Ensuring date format is correct
      time: time.toISOString(),
      name,
      email,
      message,
    };

    try {
      await createBooking(bookingData);
      alert("Your booking has been confirmed!");
      // Optionally, redirect to a confirmation page or update UI
    } catch (error) {
      console.error("Error creating booking:", error);
      alert("Failed to create booking, please try again later.");
    }
  };

  // Check if the form is valid
  const isFormValid = name && email && date && time;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Grid
        container
        /* spacing={2} */
        /* rowGap={2} */
        /*  columnSpacing={2} */
        sx={{
          /*  flexGrow: 1, */
          display: "flex",
          justifyContent: "center",
          marginLeft,
          flexDirection: { xs: "column", sm: "column", md: "row", lg: "row" },
          p: 1,
          mb: 1,
          mt: 8,
          overflow: "auto",
          width: " 100%",
        }}
      >
        <Grid
          item
          xs={11}
          sm={8}
          md={4}
          lg={4}
          sx={{
            marginRight: { xs: "0em", sm: "0em", md: "1em", lg: "1em" },
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            borderRadius: "10px",
            "&.MuiGrid-item": {
              padding: {
                xs: "2em 2em 2em 2em",
                sm: "2em 2em 2em 2em",
                md: "2em 3em 2em 3em",
                lg: "2em 3em 2em 3em",
              },
            },
          }}
        >
          <Box component="img" src={logo} alt="Logo" className={classes.logo} />
          <Divider sx={{ mb: 2 }} />

          <Typography
            gutterBottom
            sx={{ fontSize: "1.3rem", fontWeight: 800, mb: 2 }}
          >
            Como utilizar el CRM
          </Typography>
          <Typography gutterBottom sx={{ fontSize: "1.3rem", mb: 2 }}>
            Reserva cita para explicación del funcionamiento del CRM
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "row",
              maxWidth: "90%",
            }}
          >
            <VideocamOutlinedIcon
              sx={{
                marginRight: ".5em",
              }}
            />

            <Typography gutterBottom sx={{ fontSize: "1rem" }}>
              Se te enviará el enlace del vídeo por e-mail{" "}
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "row",
              maxWidth: "90%",
            }}
          >
            <TimerOutlinedIcon
              sx={{
                marginRight: ".5em",
              }}
            />
            <Typography gutterBottom sx={{ fontSize: "1rem" }}>
              20 m{" "}
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "row",
              maxWidth: "90%",
            }}
          >
            <CalendarMonthOutlinedIcon
              sx={{
                marginRight: ".5em",
              }}
            />
            <Typography gutterBottom sx={{ fontSize: "1rem" }}>
              19 de septiembre de 2024 9:20 - 9:40{" "}
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              flexDirection: "row",
              maxWidth: "90%",
            }}
          >
            <LanguageOutlinedIcon
              sx={{
                marginRight: ".5em",
              }}
            />
            <Typography gutterBottom sx={{ fontSize: "1rem" }}>
              Zona horaria Europe/Madrid{" "}
            </Typography>
          </Grid>
          <Divider sx={{ mt: 2 }} />
          <Typography gutterBottom sx={{ fontSize: "1.3rem", mt: 2 }}>
            Equipo de Stage
          </Typography>
        </Grid>

        <Grid
          item
          xs={11}
          sm={8}
          md={4}
          lg={4}
          sx={{
            marginTop: { xs: "2em", sm: "2em", md: "0em", lg: "0em" },
            marginLeft: { xs: "0", sm: "0", md: "1em", lg: "1em" },
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            borderRadius: "10px",
            "&.MuiGrid-item": {
              padding: {
                xs: "2em 2em 2em 2em",
                sm: "2em 2em 2em 2em",
                md: "2em 3em 2em 3em",
                lg: "2em 3em 2em 3em",
              },
            },
          }}
        >
          <Typography gutterBottom sx={{ fontSize: "1.3rem", fontWeight: 800 }}>
            Reserva una reunión
          </Typography>
          <TextField
            label="Name"
            fullWidth
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Email"
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Grid
            sx={{
              display: "flex",
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "row",
                lg: "row",
              },
              width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
            }}
          >
            <DatePicker
              sx={{
                mb: 2,
                marginRight: { xs: "0em", sm: "0em", md: "1em", lg: "1em" },
              }}
              label="Select Date"
              value={date}
              onChange={(newValue) => setDate(newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth sx={{ mb: 2 }} />
              )}
            />
            <TimePicker
              sx={{
                mb: 2,
                /* width: { xs: "100%", sm: "100%", md: "100%", lg: "48%" }, */
              }}
              label="Select Time"
              value={time}
              onChange={(newValue) => setTime(newValue)}
              renderInput={(params) => (
                <TextField {...params} fullWidth sx={{ mb: 2 }} />
              )}
            />
          </Grid>
          <TextField
            label="Message (Optional)"
            multiline
            rows={4}
            fullWidth
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            sx={{ mb: 2 }}
          />
          <Button
            sx={{ background: "#34afe2", width: "100%" }}
            variant="contained"
            /* color="primary" */
            onClick={handleBooking}
            disabled={!isFormValid} // Disable button if form is not valid
          >
            Confirmar
          </Button>
        </Grid>
      </Grid>
    </LocalizationProvider>
  );
};

export default BookingPage;
